<template>
    <div class="basic_tab_list">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="注册信息" name="1">
                <tab-registry-message :supplierTab="supplierTab" />
            </el-tab-pane>
            <!-- <el-tab-pane label="经营区域" name="2">
                <tab-business :supplierTab="supplierTab" />
            </el-tab-pane> -->
            <el-tab-pane label="银行账户" name="3">
                <tab-finance :supplierTab="supplierTab" />
            </el-tab-pane>
            <el-tab-pane label="盖章人信息" name="4">
                <tab-signature ref="signature" :supplierTab="supplierTab" />
            </el-tab-pane>
            <el-tab-pane label="股东信息" name="5">
                <tab-shareholder :supplierTab="supplierTab" />
            </el-tab-pane>
            <el-tab-pane label="资质信息" name="6">
                <tab-qualification :supplierTab="supplierTab" />
            </el-tab-pane>
            <el-tab-pane label="变更信息" name="7">
                <tab-modify :supplierTab="supplierTab" />
            </el-tab-pane>
            <el-tab-pane label="常跑线路" v-if="regularRouteTabVisible" name="8">
                <Tab-regular-route :supplierTab="supplierTab" />
            </el-tab-pane>
            <!-- <el-tab-pane label="司机信息" name="8">司机信息</el-tab-pane>
            <el-tab-pane label="车辆信息" name="9">车辆信息</el-tab-pane>
            <el-tab-pane label="仓库信息" name="10">仓库信息</el-tab-pane> -->
            <el-tab-pane label="叉车信息" name="15">
                <fork-truck-info />
            </el-tab-pane>
            <el-tab-pane label="零担对接平台" name="16">
                <less-than-carload :supplierTab="supplierTab" />
            </el-tab-pane>
            <el-tab-pane label="货站信息" name="17">
                <cargo-station-info />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { getSupplierInfo } from '../../../../api/registryMessageApi';
import { getSysControlParamByCode } from '../../../../api/toDo/sysParamsConfig.js'
import TabRegistryMessage from '../basicInfoTabs/TabRegistryMessage.vue';
// import TabBusiness from '../basicInfoTabs/TabBusiness';
import TabFinance from '../basicInfoTabs/TabFinance/Index.vue';
import TabSignature from '../basicInfoTabs/TabSignature/Index';
import TabQualification from '../basicInfoTabs/TabQualification/Index.vue';
import TabModify from '../basicInfoTabs/changeInformation/Index.vue';
import TabShareholder from '../basicInfoTabs/TabShareholder/Index.vue';
import TabRegularRoute from '../../manage/keyData/tabs/regularRoute/Index.vue';
import ForkTruckInfo from '../../manage/keyData/tabs/forkTruckInfo/Index.vue';
import LessThanCarload from '../../manage/keyData/tabs/lessThanCarload/Index.vue';
import CargoStationInfo from '../../manage/keyData/tabs/cargoStationInfo/Index.vue';
import { LOGISTICS_SUPPLIER } from '../../../../constant/constant';

export default {
    name: 'tab-list',
    components: { TabRegistryMessage, TabFinance, TabSignature, TabQualification, TabModify, TabShareholder, TabRegularRoute, ForkTruckInfo, LessThanCarload, CargoStationInfo },
    data() {
        return {
            activeName: '1',
            supplierTab: {},
            overseaSwitch: true, // 涉外业务类型 显示开关
        };
    },
    computed: {
        userCode() {
            return this.$store.state.user.userCode;
            // return '11_0005'; // 测试userCode
        },
        regularRouteTabVisible() {
            return this.supplierTab.supplierType === LOGISTICS_SUPPLIER;
        }
    },
    methods: {
        handleClick(tab) {
            // if(tab.name === '4' && this.supplierTab.propertyNature === '1'){
            //     //主体性质=法人，切换到盖章人信息页签，需要自动同步
            //     this.$nextTick(() => {
            //         this.$refs['signature'].handleSynchronize()
            //     })
            // }
        },
        getInFo() {
            getSupplierInfo(this.userCode).then(res => {
                if (res && res.data) {
                    const { supplierCode, propertyNature, supplierNameCn, transType, supplierType } = res.data;
                    this.supplierTab = {
                        supplierCode,
                        supplierType,
                        propertyNature,
                        supplierName: supplierNameCn,
                        transType,
                        overseaSwitch: this.overseaSwitch,
                    };
                }
            });
        },
        getOverseaConfig() {
            return getSysControlParamByCode({ controlCode: 'OVERSEA_SWITCH' }).then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.overseaSwitch = !!JSON.parse(res.data)
                }
            }).catch(err => {})
        },
    },
    async mounted() {
        await this.getOverseaConfig()
        this.getInFo();
        // 判断是否从抢单权限申请页跳转过来，如果是初始显示页签为资质信息
        if (this.$route.params.tabQualifi) {
            this.activeName = '6';
        } else if (this.$route.query.tabFinance) {
            this.activeName = '3';
        }
    }
};
</script>

<style lang="less">
    .basic_tab_list {
        .el-tabs__item {
            font-size: 14px;
            color: #666666;
        }
    }
    .operate_station_dialog div.baidu_map_input {
        margin-top: 2px;
    }
 </style>
